module.exports = __webpack_public_path__ + "static/media/ongoingAdvice.e58bb13d.png";